/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BillCache = {
    type?: BillCache.type | null;
    from_entity?: any;
    to_entity?: any;
    generate_integration_bill?: boolean;
}

export namespace BillCache {

    export enum type {
        PATIENT = 'patient',
        INSURANCE = 'insurance',
        INTRACOMPANY = 'intracompany',
        EXTERNAL = 'external',
        CLIENT = 'client',
        PURCHASE = 'purchase',
        TEST = 'test',
        UNKNOWN = 'unknown',
    }


}
